import React from "react";
import AppHeaderCore from "./AppHeaderCore";
import logo from "../../../../media/images/service-link-logo.png";
import moment from "moment";
const AppHeader = (props) => {
    const banner = (<div className="banner">
			<div className="banner-wrapper">
				<div className="banner-wrapper-content">
					{!!props.lastLogin && (<span style={{ paddingRight: "20px" }}>
							Last Login: {moment.utc(props.lastLogin).local().format("M/DD/YYYY h:mm a")}
						</span>)}
					<span>
						Need help? Call us:{" "}
						<a href="tel:+18773268786" itemProp="telephone" className="banner-wrapper-content-link">1-877-326-8786</a>
					</span>
				</div>
			</div>
		</div>);
    return (<AppHeaderCore {...props} title="DCMS ServiceLink Home" logo={logo} logoAlt="DCMS ServiceLink a product of DCM Services home" banner={banner}/>);
};
export default AppHeader;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/AppHeader/AppHeader.tsx